import cpf from './cpf'
import cnpj from './cnpj'

export default cpfCnpj => {
  if (cpfCnpj) {
    if (cpfCnpj.length <= 11) {
      return cpf(cpfCnpj)
    }

    return cnpj(cpfCnpj)
  }

  return true
}

export { cpf, cnpj }
